module.exports = __webpack_public_path__ + "media/images/emblems/Baetterkinden-coat_of_arms-216467ace71c00d57174b9174c35c1e4.svg";